export const strings = {
  dochody: "DOCHODY",
  wydatki: "WYDATKI",
};
